const { default: axiosIns } = require('@/libs/axios')

const AdDebuggerService = {

  // GET - AdDebuggerApiController
  async getAdDebugger() {
    return axiosIns.get('admin/addebugger').then(response => response.data)
  },
}

export default AdDebuggerService
